import React, { useContext } from 'react'
import { sessionContext, useGetBusinessIDIfExists } from '@marketing-milk/frontend'
import { getNavLinks } from './getNavLinks'
import { useScreenSize } from 'hooks'
import { NavLink } from './NavLink'

export const DesktopNav = () => {
  const { user } = useContext(sessionContext)
  const { isMobile } = useScreenSize()
  const businessID = useGetBusinessIDIfExists()
  const links = getNavLinks(businessID, user).filter(l => l.visible !== false)

  if (isMobile) return null
  return (
    <div
      style={{ background: '#1e1e2d' }}
      className="h-screen flex flex-col relative"
      data-testid="sidebar-navigation"
    >
      <a
        href="https://dashboard.marketingmilk.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex justify-center items-center w-full h-16 bg-purple-800"
      >
        <img
          src={
            'https://www.marketingmilk.com/wp-content/themes/marketing-milk/static/img/marketing-milk-logo-white.svg'
          }
          alt="marketing-milk marketing milk logo"
          style={{ maxHeight: '30px' }}
        />
      </a>

      <div
        className="space-y-1 mx-auto text-center flex-1 overflow-y-auto w-full sidenav-scroll"
        style={{ scrollbarWidth: 'thin', scrollbarColor: '#5f6080 transparent' }}
      >
        <NavLink
          route={{
            label: 'Businesses',
            icon: 'briefcase',
            url: 'dashboard',
          }}
        />
        {!businessID &&
          links
            .filter(l => l.externalLink)
            .map(route => <NavLink key={route.label} route={route} />)}
        {businessID && links.map(route => <NavLink key={route.label} route={route} />)}
      </div>

      <style>{`
        .sidenav-scroll::-webkit-scrollbar { width: 6px; }
        .sidenav-scroll::-webkit-scrollbar-track { background: transparent; }
        .sidenav-scroll::-webkit-scrollbar-thumb { background: #5f6080; border-radius: 3px; }
        .sidenav-scroll::-webkit-scrollbar-thumb:hover { background: #80829e; }
      `}</style>
    </div>
  )
}
